import logger from '../logger';
import { getApplePaySession } from '../windowGlobals';

const isApplePayCompatible = () => {
    const ApplePaySessionCtor = getApplePaySession();
    if (!ApplePaySessionCtor) {
        logger.showLog('info', 'This device does not support Apple Pay');
        return false;
    }

    if (!ApplePaySessionCtor.canMakePayments()) {
        logger.showLog('info', 'This device is not capable of making Apple Pay payments');
        return false;
    }

    if (!ApplePaySessionCtor.supportsVersion(3)) {
        logger.showLog('info', 'This device does not support version 3 of Apple Pay');
        return false;
    }

    return true;
};

export default isApplePayCompatible;
